import Layout from "../../components/mainPage/Layout";
import manufactureImg from "../../images/manufacture.png"
import { Add } from "shared/components/Add";
import { ImageContainer } from "shared/components/ImageContainer";
import image from '../../images/transport.png'

export const Page = () => {
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="acticle-title" >
            Транспорт
          </h1>
          <h2 className="section-title">
            SCADA NPT Expert+ для умного управления объектами транспортной инфраструктуры, трубопроводами и сопутствующими сооружениями
          </h2>
          <p>
            Обеспечение бесперебойного и безопасного энергоснабжения транспортных систем и магистральных трубопроводов — ключевая задача для функционирования национальной инфраструктуры. </p>
          <p>
            <strong>SCADA-система</strong> выступает центральным интеллектуальным ядром для управления энергетическими объектами железных дорог и систем транспортировки углеводородов.    </p>

          <h2 className="section-title">
            Варианты применения SCADA NPT Expert+ на разных объектах транспорта:
          </h2>
          <div className="variants-list">
            <div className="quote-box">
              <h5><strong>🔵 Решения для железнодорожного транспорта (РЖД и метрополитен)</strong></h5>
              <p><strong>Объекты автоматизации:</strong></p>
              <ul>
                <li>Тяговые подстанции</li>
                <li>Устройства секционирования и параллельного соединения контактной сети</li>
                <li>Системы дистанционного питания автоматики, сигнализации и связи</li>
                <li>Резервные дизель-генераторные установки на станциях и тоннелях</li>
                <li>Системы освещения станций, тоннелей, депо и вокзалов</li>
              </ul>
              <p><strong>Ключевые функции SCADA:</strong></p>
              <ul>
                <li>Диспетчерское управление схемой электроснабжения контактной сети</li>
                <li>Автоматический ввод резерва (АВР)</li>
                <li>Мониторинг уровня износа контактного провода и нагрузок на секциях</li>
                <li>Интеграция с системами энергоучета и АСКУЭ для биллинга арендаторов путей</li>
                <li>Формирование графиков планового отключения для ремонтов</li>
              </ul>
              <p><strong>Преимущества:</strong></p>
              <ul className="benefits-list">
                <li className="alert alert-success">
                  <span className="icon m-1">✅</span>
                  Сокращение задержек поездов из-за нарушений электроснабжения и других инцидентов
                </li>
                <li className="alert alert-success">
                  <span className="icon m-1">✅</span>
                  Снижение эксплуатационных расходов
                </li>
                <li className="alert alert-success">
                  <span className="icon m-1">✅</span>
                  Повышение электробезопасности для персонала и пассажиров
                </li>
              </ul>

            </div>
            <div className="quote-box">
              <h5><strong>🟢 Решения для магистральных трубопроводов (нефть, газ, нефтепродукты)</strong></h5>
              <p><strong>Объекты автоматизации:</strong></p>
              <ul>
                <li>Электроприводные станции (ЭПС) главных насосных и компрессорных агрегатов</li>
                <li>Собственные ТЭЦ, ГПА и когенерационные установки</li>
                <li>Распределительные сети вдоль трасс трубопроводов</li>
                <li>Системы катодной защиты труб от коррозии</li>
                <li>Резервное энергоснабжение удаленных задвижек и пунктов контроля</li>
              </ul>
              <p><strong>Ключевые функции SCADA:</strong></p>
              <ul>
                <li>Приоритетное управление нагрузкой при аварийных остановках ЭПС</li>
                <li>Мониторинг качества электроэнергии для чувствительного приводного оборудования</li>
                <li>Автоматическое регулирование частоты и напряжения на изолированных энергообъектах</li>
                <li>Управление режимами рекуперации с турбодетандеров и систем редукции давления</li>
                <li>Интеграция с АСУ ТП трубопровода для единого окна управления</li>
              </ul>
              <p><strong>Преимущества:</strong></p>
              <ul className="benefits-list">
                <li className="alert alert-success">
                  <span className="icon m-1">✅</span>
                  Гарантированное энергоснабжение непрерывного цикла транспортировки
                </li>
                <li className="alert alert-success">
                  <span className="icon m-1">✅</span>
                  Оптимизация затрат на топливо для собственной генерации
                </li>
                <li className="alert alert-success">
                  <span className="icon m-1">✅</span>
                  Предотвращение простоев из-за энергетических сбоев
                </li>
              </ul>
            </div>

          </div>

          <ImageContainer
            src={image}
            alt={'SCADA NPT Expert в работе на современной тяговой ПС'}
            caption={'SCADA NPT Expert в работе на современной тяговой ПС'}
          />
          <Add
            text={<>Автоматизируйте Ваши объекты транспортной инфраструктуры с передовыми <span style={{ letterSpacing: '1px', color: '#ea4335', fontWeight: '800' }}>SCADA NPT решениями!</span> </>}
            description={'Управляйте с уверенностью в завтрашнем дне!'}
            image={manufactureImg}
          />
        </div>
      </div>
    </Layout>
  );
}

export const meta = {
  title: 'Транспорт',
  description: 'SCADA NPT Expert+ для умного управления объектами транспортной инфраструктуры, трубопроводами и сопутствующими сооружениями'
}
